module.exports = __webpack_public_path__ + "img/31.7cf446c1.png";